// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Split-module--wrapper--1aUzN","standard":"Split-module--standard--1K2Kf","reverse":"Split-module--reverse--3mPFJ"};